class LiveNewsDTO {
    constructor(params) {
        this.category = params.category;
        this.customElements = params.customElements;
        this.category = params.category;
        this.date = params.date;
        this.desc = params.desc;
        this.guid = params.guid;
        this.timeText = params.timeText;
        this.title = params.title;
    }
}
export default LiveNewsDTO;
